const items = [
  "Know your numbers before month-end",
  "Get paid faster",
  "Stay ahead of BAS & tax",
  "Forecast with confidence",
  "Grow without the cash squeeze",
  "Built for Australian businesses",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      className="relative overflow-hidden bg-[#0B2B4B] py-5 border-y border-[#16345C]"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-display text-sm sm:text-base font-semibold uppercase tracking-[0.14em] text-white/90">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#0FA3E8]" />
          </span>
        ))}
      </div>
    </div>
  );
}
